import { useCatalogFiltersData } from 'features/spatial-data-catalog/hooks/useCatalogFilters'
import { useIframePostMessage } from 'features/spatial-data-catalog/hooks/useIframePostMessage'
import { ReactElement, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

export function DataCatalogRouteNotifier({ children }: { children: ReactElement }) {
  const location = useLocation()
  const { filters } = useCatalogFiltersData()
  const [initialized, setInitialized] = useState(false)
  const { postMessage } = useIframePostMessage()

  useEffect(() => {
    const mustNotify = location.pathname.includes('dataset') || location.pathname.includes('browser')

    if (!mustNotify) {
      return
    }

    if (!initialized) {
      setInitialized(true)
      return
    }

    let params: Record<string, unknown> = {
      type: 'browser',
      params: Object.keys(filters).reduce((acc, key) => {
        if (filters[key].length) {
          acc[key] = Array.from(new Set(filters[key]))
        }
        return acc
      }, {})
    }
    if (location.pathname.includes('dataset')) {
      params = {
        type: 'dataset',
        slug: location.pathname.split('/').pop()
      }
    }
    postMessage(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, filters, postMessage])

  return children
}
